import { useParams, useNavigate } from 'react-router-dom';
import { Navbar } from '@/components/layout/Navbar';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Carousel, CarouselContent, CarouselItem } from '@/components/ui/carousel';
import { MapPin, Star, Clock, Wallet, Plus, Heart, Navigation, Share2, Wifi, Car, Accessibility, Dog } from 'lucide-react';

const images = ['beijing,scenery', 'beijing,temple', 'beijing,palace'];

const goods = [
  { name: '故宫门票+讲解', price: 88, original: 128 },
  { name: '故宫文创套装', price: 68, original: 98 },
];

const comments = [
  { user: '游客A', rating: 5, content: '非常震撼，值得一去！' },
  { user: '旅行者B', rating: 4, content: '人很多，建议早点来。' },
];

const facilities = [
  { icon: Wifi, label: 'WiFi' },
  { icon: Car, label: '停车场' },
  { icon: Accessibility, label: '无障碍' },
  { icon: Dog, label: '宠物友好' },
];

const POIDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-bg-primary">
      <Navbar />
      <div className="max-w-6xl mx-auto px-4 md:px-6 pt-24 pb-20">
        <Carousel className="w-full mb-6">
          <CarouselContent>
            {images.map((img, i) => (
              <CarouselItem key={i}>
                <div className="h-[250px] rounded-card overflow-hidden shadow-card">
                  <img src={`https://picsum.photos/seed/${img}/1200/500`} alt="" className="w-full h-full mx-auto object-cover" />
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
        </Carousel>

        <Card className="border-0 shadow-card rounded-card bg-white mb-6">
          <CardContent className="p-6">
            <h1 className="text-2xl font-bold text-text-primary mb-2">故宫博物院</h1>
            <div className="flex items-center gap-2 mb-3">
              <span className="text-primary text-lg">{'★'.repeat(5)}</span>
              <span className="text-sm text-text-secondary">4.9 (1.2万条评价)</span>
            </div>
            <div className="flex flex-wrap gap-2 mb-4">
              <Badge className="bg-primary-light text-primary rounded-full">5A景区</Badge>
              <Badge className="bg-primary-light text-primary rounded-full">世界文化遗产</Badge>
            </div>
            <div className="space-y-2 text-sm text-text-secondary">
              <p className="flex items-center gap-2"><MapPin className="w-4 h-4 text-primary" /> 北京市东城区景山前街4号</p>
              <p className="flex items-center gap-2"><Clock className="w-4 h-4 text-primary" /> 08:30-17:00（周一闭馆）</p>
              <p className="flex items-center gap-2"><Wallet className="w-4 h-4 text-primary" /> 人均 ¥60</p>
            </div>
          </CardContent>
        </Card>

        <div className="flex gap-3 mb-6">
          <Button className="flex-1 bg-primary hover:bg-primary-hover text-white rounded-btn"><Plus className="w-4 h-4 mr-1" /> 加入行程</Button>
          <Button variant="outline" className="rounded-btn border-[#E8E4DF]"><Heart className="w-4 h-4" /></Button>
          <Button variant="outline" className="rounded-btn border-[#E8E4DF]"><Navigation className="w-4 h-4" /></Button>
          <Button variant="outline" className="rounded-btn border-[#E8E4DF]"><Share2 className="w-4 h-4" /></Button>
        </div>

        <Card className="border-0 shadow-card rounded-card bg-white mb-6">
          <CardContent className="p-6">
            <h2 className="font-bold text-text-primary mb-3">关于此处</h2>
            <p className="text-sm text-text-secondary leading-relaxed">故宫是中国明清两代的皇家宫殿，旧称紫禁城，位于北京中轴线的中心，是中国古代宫廷建筑之精华。</p>
          </CardContent>
        </Card>

        <div className="grid grid-cols-4 gap-3 mb-6">
          {facilities.map((f, i) => (
            <div key={i} className="bg-white rounded-card shadow-card p-3 flex flex-col items-center text-center">
              <f.icon className="w-5 h-5 text-primary mb-1" />
              <span className="text-xs text-text-secondary">{f.label}</span>
            </div>
          ))}
        </div>

        <Card className="border-0 shadow-card rounded-card bg-white mb-6">
          <CardContent className="p-6">
            <h2 className="font-bold text-text-primary mb-4">团购商品</h2>
            <div className="flex gap-4 overflow-x-auto pb-2">
              {goods.map((g, i) => (
                <Card key={i} className="min-w-[200px] border border-[#E8E4DF] rounded-card bg-white">
                  <CardContent className="p-4">
                    <p className="text-sm font-medium text-text-primary mb-2">{g.name}</p>
                    <div className="flex items-end gap-2 mb-3">
                      <span className="text-lg font-bold text-primary">¥{g.price}</span>
                      <span className="text-xs text-text-tertiary line-through">¥{g.original}</span>
                    </div>
                    <Button size="sm" className="w-full bg-primary hover:bg-primary-hover text-white rounded-smwidget text-xs">抢购</Button>
                  </CardContent>
                </Card>
              ))}
            </div>
          </CardContent>
        </Card>

        <Card className="border-0 shadow-card rounded-card bg-white mb-6">
          <CardContent className="p-6">
            <h2 className="font-bold text-text-primary mb-4">用户评价</h2>
            <div className="space-y-4">
              {comments.map((c, i) => (
                <div key={i} className="pb-4 border-b border-[#E8E4DF] last:border-0">
                  <div className="flex items-center gap-2 mb-1">
                    <div className="w-7 h-7 rounded-full bg-bg-secondary flex items-center justify-center text-xs text-text-secondary">{c.user[0]}</div>
                    <span className="text-sm font-medium text-text-primary">{c.user}</span>
                    <span className="text-primary text-xs">{'★'.repeat(c.rating)}</span>
                  </div>
                  <p className="text-sm text-text-secondary">{c.content}</p>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>

        <div>
          <h2 className="font-bold text-text-primary mb-4">附近推荐</h2>
          <div className="flex gap-4 overflow-x-auto pb-2">
            {[1, 2, 3].map((i) => (
              <Card key={i} className="min-w-[200px] border-0 shadow-card rounded-card bg-white overflow-hidden cursor-pointer" onClick={() => navigate(`/poi/${i}`)}>
                <div className="h-28 bg-bg-secondary">
                  <img src={`https://picsum.photos/seed/beijing/400/300`} alt="" className="w-full h-full mx-auto object-cover" />
                </div>
                <CardContent className="p-3">
                  <p className="text-sm font-medium text-text-primary">附近景点 {i}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default POIDetail;
